export const theme: Theme = {
  colors: {
    background: "#1c1c1c",
    primary: "#F9CD11",
    primaryDark: "#d8b207",
    secondary: "#FFFFFF",
    white: "#FFFFFF",
    text: "#ededed",
    textInactive: "rgba(237, 237, 237, 0.5)",
    dark: "#1c1c1c",
    linearGradientPrimary: "-webkit-linear-gradient(#00c89a, #f9cd11);",
    inputBorder: "#3e3e3e",
    tagBg: "#f9cd1126",
    tagText: "#F3B61F",
    error400: "rgba(229, 75, 75, 0.40)",
    error: "rgba(229, 75, 75, 1)",
    ok400: "rgba(23, 195, 123, 0.40)",
    ok: "rgba(23, 195, 123, 1)",
    loading450: "rgba(249, 247, 232, 0.45)",
    loading: "rgba(249, 247, 232, 1)",
    singleLinkBg: "#232323",
    privateBg: "rgba(229, 149, 75, 0.15)",
    privateText: "#E5954B",
    publicBg: "rgba(23, 112, 195, 0.15)",
    publicText: "#1770C3",
  },

  fontSize: {
    XS: "12px",
    S: "14px",
    M: "16px",
    L: "32px",
    XL: "36px",
    XXL: "48px",
    Button: "16px",
    ButtonL: "20px",
    LogoSmall: "20px",
    LogoLarge: "24px",
    Input: "16px",
  },

  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },

  radii: {
    default: "8px",
    small: "5px",
  },
};

export type Theme = {
  colors: {
    background: string;
    primary: string;
    primaryDark: string;
    secondary: string;
    white: string;
    text: string;
    textInactive: string;
    dark: string;
    linearGradientPrimary: string;
    inputBorder: string;
    tagBg: string;
    tagText: string;
    error400: string;
    error: string;
    ok400: string;
    ok: string;
    loading450: string;
    loading: string;
    singleLinkBg: string;
    privateBg: string;
    privateText: string;
    publicBg: string;
    publicText: string;
  };

  fontSize: {
    XS: string;
    S: string;
    M: string;
    L: string;
    XL: string;
    XXL: string;
    Button: string;
    ButtonL: string;
    LogoSmall: string;
    LogoLarge: string;
    Input: string;
  };

  fontWeight: {
    light: number;
    regular: number;
    medium: number;
    semibold: number;
    bold: number;
    extrabold: number;
    black: number;
  };

  radii: {
    default: string;
    small: string;
  };
};
